import "../css/style.scss"
import '../node_modules/leaflet/dist/leaflet.css'

import Search from "./modules/Search"
import "./modules/contact-form"
//import { mainMap } from './modules/map-hl'; // Import the initializeMap function
//import { initMiniMap } from './modules/map-hl';

import { PlayerElement } from "html-midi-player"

const search = new Search()
/*
// Call the function to set up the map
document.addEventListener('DOMContentLoaded', () => {
    if (document.getElementById('map-hl')) {
        mainMap();
    }
});
// keep this public so it can be used by dynamic inline coode
window.initMiniMap = initMiniMap;
*/
